import React from 'react';
import cn from 'classnames';

import styles from './success.module.scss';

const Success: React.FC<
  React.PropsWithChildren<{
    readonly children: string;
    readonly className?: string;
  }>
> = ({ children, className }) => {
  return <div className={cn(styles.container, className)}>{children}</div>;
};

export default Success;
